import request from '../utils/request'

export function getArtworkDetail(id) {
    return request({
        url: `artwork/detail/${id}`,
        method: 'get'
    })
}

export function getPixiId(id) {
    return request({
        url: `artwork/pixi/${id}`,
        method: 'get'
    })
}